import {
  SlAnimatedImage
} from "./chunk.F4PDI6XK.js";

// src/components/animated-image/animated-image.ts
var animated_image_default = SlAnimatedImage;
SlAnimatedImage.define("sl-animated-image");

export {
  animated_image_default
};
